import styled, { css } from 'styled-components';
import { Color, FontSize, LineHeight, Spacing, ShapeRadius, UnitSize } from '@pushwoosh/kit-constants';
export const TextInputLeftSide = styled.div.withConfig({
  displayName: "TextInputLeftSide",
  componentId: "sc-1g57mi3-0"
})(["position:absolute;top:0;left:", ";bottom:0;margin:auto;height:", ";color:", ";pointer-events:none;"], Spacing.S2, UnitSize.ICON_MEDIUM, ({
  $hasValue
}) => $hasValue ? Color.LOCKED : Color.PHANTOM);
const FlexStyles = css(["display:flex;flex-direction:row;align-items:stretch;justify-content:stretch;"]);
export const TextInputBox = styled.div.withConfig({
  displayName: "TextInputBox",
  componentId: "sc-1g57mi3-1"
})(["", " position:relative;&:focus-within{", "{color:", ";}}&:hover{", "{color:", ";}}"], ({
  $hasLeftStuck,
  $hasRightStuck
}) => $hasLeftStuck || $hasRightStuck ? FlexStyles : '', TextInputLeftSide, Color.BRIGHT, TextInputLeftSide, Color.PRIMARY_HOVER);
export const TextInputField = styled.input.withConfig({
  displayName: "TextInputField",
  componentId: "sc-1g57mi3-2"
})(["height:", ";width:100%;padding-top:0;padding-bottom:0;padding-left:", ";padding-right:", ";border:1px solid ", ";border-top-left-radius:", ";border-top-right-radius:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";font-size:", ";line-height:", ";background-color:", ";&:focus{outline:none;border-color:", ";}&:disabled{background-color:", ";}&::placeholder{color:", ";}", ""], UnitSize.FIELD_HEIGHT, ({
  $withIcon
}) => $withIcon ? `calc(${Spacing.S2} + ${UnitSize.ICON_MEDIUM} + ${Spacing.S1} - 1px)` : `calc(${Spacing.S4} - 1px)`, ({
  $isClearable
}) => $isClearable ? `calc(${Spacing.S4} + ${UnitSize.ICON_SMALL} + ${Spacing.S1} - 1px)` : `calc(${Spacing.S4} - 1px)`, ({
  $isErrored
}) => $isErrored ? Color.DANGER : Color.FORM, ({
  $hasLeftStuck
}) => $hasLeftStuck ? 0 : ShapeRadius.CONTROL, ({
  $hasRightStuck
}) => $hasRightStuck ? 0 : ShapeRadius.CONTROL, ({
  $hasLeftStuck
}) => $hasLeftStuck ? 0 : ShapeRadius.CONTROL, ({
  $hasRightStuck
}) => $hasRightStuck ? 0 : ShapeRadius.CONTROL, FontSize.REGULAR, LineHeight.REGULAR, Color.CLEAR, Color.BRIGHT, Color.FROZEN, Color.PHANTOM, props => props.$withIcon ? `
    &:hover:not(:focus) {
      color: ${Color.PRIMARY_HOVER};
      font-weight: 500;
      background-color: ${Color.BRIGHT_LIGHT};
    }
  ` : '');
export const TextInputRightSide = styled.div.withConfig({
  displayName: "TextInputRightSide",
  componentId: "sc-1g57mi3-3"
})(["position:absolute;display:flex;top:0;right:", ";bottom:0;margin:auto;height:", ";"], Spacing.S3, UnitSize.ICON_SMALL);
export const TextInputRightSlot = styled.div.withConfig({
  displayName: "TextInputRightSlot",
  componentId: "sc-1g57mi3-4"
})(["display:inline-flex;color:", ";background-color:transparent;align-items:center;"], Color.PHANTOM);
export const TextInputCleanButton = styled.button.withConfig({
  displayName: "TextInputCleanButton",
  componentId: "sc-1g57mi3-5"
})(["padding:0;border:none;appearance:none;color:", ";background-color:transparent;&:hover{color:", ";}&:active{color:", ";}"], Color.PHANTOM, Color.DANGER_HOVER, Color.DANGER_PRESSED);
const TextInputStuck = styled.div.withConfig({
  displayName: "TextInputStuck",
  componentId: "sc-1g57mi3-6"
})(["border:", " solid ", ";display:flex;flex-direction:row;justify-content:center;align-items:center;"], ({
  $borderWidth = 1
}) => `${$borderWidth}px`, Color.FORM);
export const TextInputLeftStuck = styled(TextInputStuck).withConfig({
  displayName: "TextInputLeftStuck",
  componentId: "sc-1g57mi3-7"
})(["border-right:none;&,& > *,button,.kit-select__control{border-radius:", " 0 0 ", ";}button,.kit-select__control{margin-right:-1px;}"], ShapeRadius.CONTROL, ShapeRadius.CONTROL);
export const TextInputRightStuck = styled(TextInputStuck).withConfig({
  displayName: "TextInputRightStuck",
  componentId: "sc-1g57mi3-8"
})(["border-left:none;&,& > *,button,.kit-select__control{border-radius:0 ", " ", " 0;}button,.kit-select__control{margin-left:-1px;}"], ShapeRadius.CONTROL, ShapeRadius.CONTROL);
TextInputBox.displayName = 'TextInputBox';
TextInputLeftSide.displayName = 'TextInputLeftSide';
TextInputField.displayName = 'TextInputField';
TextInputRightSide.displayName = 'TextInputRightSide';
TextInputCleanButton.displayName = 'TextInputCleanButton';